import { jsx } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
function MaybeFragment(_ref) {
  let {
    as: Component = "div",
    children,
    ...props
  } = _ref;
  if (Object.values(props).some(value => value != null)) {
    return /* @__PURE__ */jsx(Component, {
      ...props,
      children
    });
  }
  return /* @__PURE__ */jsx(Fragment, {
    children
  });
}
export { MaybeFragment as default };